/**
 * ConfirmationStep Component
 *
 * Success confirmation after advisory request creation
 */

import React from 'react';

import { useNavigate } from 'react-router-dom';

import { Box } from '@mui/material';

import * as S from './styles';
import Button from 'components/Button';
import Text from 'components/Text';

interface ConfirmationStepProps {
  requestId: string;
  handleGoToLeadRequestPanel: () => void;
}

const ConfirmationStep: React.FC<ConfirmationStepProps> = ({
  requestId,
  handleGoToLeadRequestPanel,
}) => {
  const navigate = useNavigate();

  return (
    <S.ConfirmationContainer>
      <S.SuccessIcon>✅</S.SuccessIcon>

      <Text size="XXLarge" bold textAlign="center" color="green">
        Solicitação de lead enviada com sucesso!
      </Text>

      <Box mt={2} mb={3}>
        <Text size="medium" textAlign="center" color="textSecondary">
          Sua solicitação de lead foi criada e está sendo revisada pela nossa equipe.
        </Text>
      </Box>

      <S.InfoBox>
        <Text size="small" bold color="textPrimary">
          ID da solicitação:
        </Text>
        <Text size="small" color="textSecondary">
          {requestId}
        </Text>
      </S.InfoBox>

      <S.InfoBox>
        <Text size="medium" textAlign="center" color="textSecondary">
          📧 Você receberá um email quando você for correspondido com um lead.
        </Text>
      </S.InfoBox>

      <S.ButtonGroup>
        <Button
          variant="outline"
          onClick={() => navigate('/advisory/sponsor/request')}
          size="medium"
        >
          Criar outra solicitação
        </Button>
        <Button variant="primary" onClick={handleGoToLeadRequestPanel} size="medium">
          Ir para o painel
        </Button>
      </S.ButtonGroup>
    </S.ConfirmationContainer>
  );
};

export default ConfirmationStep;
